//src/components/chat/ChatHeader.js
import React from 'react';
import { Phone, MoreVertical } from 'lucide-react';
import SessionMenu from './SessionMenu';

const ChatHeader = ({ currentChat }) => {
    if (!currentChat) return null;

    // Get initials from name or use first character of phone number
    const getInitials = (name) => {
        // If name is undefined or literally the string "undefined", use the phone
        if (!name || name === "undefined") return currentChat.phone.substring(0, 2);

        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    // Handle case where name is "undefined"
    const displayName = currentChat.name === "undefined" ?
        currentChat.phone : (currentChat.name || 'Unknown');

    return (
        <div className="bg-white border-b px-6 py-4 flex items-center justify-between">
            <div className="flex items-center">
                {/* Avatar */}
                <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-semibold">
                    {getInitials(currentChat.name)}
                </div>

                {/* Contact Info */}
                <div className="ml-4">
                    <h3 className="text-lg font-semibold text-gray-900">
                        {displayName}
                    </h3>
                    <div className="flex items-center text-sm text-gray-500">
                        <Phone size={14} className="mr-1" />
                        <span>{currentChat.phone}</span>
                    </div>
                </div>
            </div>

            {/* Actions */}
            <div className="flex items-center space-x-4">
                <SessionMenu phone={currentChat.phone} />
            </div>
        </div>
    );
};

export default ChatHeader;